<template>
  <div class="container">
    <div class="wrap-confirmation">
      <div class="title">
        Mitra Perbankan Rekening Peserta Emas Digital
      </div>
      <div class="wrap-bank">
        <router-link to="/login-bank" v-if="platform != 'Goldex'">
          <div class="choose-bank bagi" @click="haveBAGI">
            <img src="../assets/logo-agi-vertical.png" alt="" />
          </div>
        </router-link>
        <div class="wrap-cimb" v-else>
          <div class="choose-bank cimb" @click="openModal(1)">
            <img src="../assets/logo_cimb_niaga.png" alt="" />
          </div>
          <div class="choose-bank cimb-syariah" @click="openModal(4)">
            <img src="../assets/syariah.png" alt="" />
          </div>
        </div>
        <!-- <div class="choose-bank ocbc" @click="openModal(3)">
        <img src="../assets/logo_ocbc.png" alt="" />
      </div> -->
      </div>
      <!-- Modal -->
      <div class="self-modal" v-show="selected" ref="selfModal" id="modal">
        <div class="content-modal">
          <div class="title-modal">
            <span>{{ title }}</span>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="(selected = false), (warning = false)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="body-modal">
            Apakah anda memiliki rekening tabungan {{ title }}?
            <div class="error" v-show="warning">
              Silahakan Membuka Rekening {{ title }} terlebih dahulu.
              <br />
              <div v-show="title == 'CIMB NIAGA'">
                Download OCTO Mobile
                <div class="img-error">
                  <a class="error img-error" href="https://play.google.com/store/apps/details?id=id.co.cimbniaga.mobile.android&hl=en&gl=US" target="_blank"
                    ><img src="../assets/play.png" alt=""
                  /></a>

                  <a class="error img-error" href="https://apps.apple.com/id/app/octo-mobile-by-cimb-niaga/id505917174" target="_blank"
                    ><img src="../assets/app.png" alt="" />
                  </a>
                </div>
              </div>
              <div v-show="title == 'BANK ARTHA GRAHA'">
                AGI Mobile
                <div class="img-error">
                  <a class="error img-error" href="https://play.google.com/store/apps/details?id=com.dwidasa.bag.mb.android" target="_blank"
                    ><img src="../assets/play.png" alt=""
                  /></a>

                  <a class="error img-error" href="https://apps.apple.com/id/app/agi-mobile/id1326708542" target="_blank"><img src="../assets/app.png" alt="" /> </a>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-modal">
            <button class="btn-scondary" @click="warning = true">Tidak</button>
            <router-link to="/login-bank">
              <button class="btn-scondary">Ya</button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="self-modal" v-show="selectedStatement" ref="selfModal" id="modal">
        <div class="content-modal">
          <div class="title-modal">
            <span>{{ title }}</span>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="(selected = false), (warning = false)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="body-modal">
            Syarat Syarat Pembukaan rekening
          </div>
          <div class="text-center d-flex justify-center">
            <!-- <button class="btn-scondary" @click="warning = true">Tidak</button> -->

            <button class="btn-primer" @click="selectedStatement = false">Setuju</button>
          </div>
        </div>
      </div>
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Rekening CIMB Niaga
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              Silahkan Melakukan Pembukaan Rekening CIMB Niaga Melalui Aplikasi Octo Mobile CIMB Niaga, Untuk melanjutkan proses registrasi PosGO Syariah
            </div>
            <div class="modal-footer">
              <a href="https://play.google.com/store/apps/details?id=id.co.cimbniaga.mobile.android&hl=en&gl=US" target="_blank">
                <button type="submit" class="btn-primer aplikasi" aria-hidden="true">
                  Setuju
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: "",
      title: "",
      selected: false,
      selectedStatement: false,
      warning: false,
      slide: 1,
      platform: "",
    };
  },
  mounted() {
    this.date = new Date();
    this.platform = localStorage.getItem("platform");
    // console.log(current)
  },
  methods: {
    // openModal() {
    //   console.log("berhasil");
    // },
    noHaveAccount() {
      localStorage.setItem("giro_pos", 0);
      this.$router.push("/register-datapribadi");
    },
    openModal(e) {
      localStorage.setItem("code", e);
      this.selected = true;
      if (e === 1) {
        this.title = "CIMB NIAGA";
      } else if (e === 2) {
        this.title = "BANK ARTHA GRAHA";
      } else if (e === 3) {
        this.title = "BANK OCBC";
      } else if (e === 4) {
        this.title = "CIMB NIAGA SYARIAH";
      }
    },
    haveBAGI() {
      localStorage.setItem("code", 2);
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.wrap-confirmation {
  margin-top: 50px;
  width: 70%;
}

.title {
  font-weight: bold;
  background: var(--primary);
  color: #fff;
  padding: 25px;
  width: 80%;
  margin: 0 auto;
  text-align: center;
  border-radius: 10px 10px 0 0;
}

.confirmation-statment {
  font-size: 20px;
  margin-bottom: 60px;
}

.wrap-bank {
  width: 100%;
  gap: 50px;
  background: #fff;
  padding: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

.wrap-cimb {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
}

.choose-bank {
  width: 15rem;
  height: 13rem;
  padding: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  margin: 0 auto;
}

/* .choose-bank:hover {
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.75);
} */

.cimb:hover {
  border: none;
  box-shadow: 0px 0px 10px 3px rgba(120, 0, 1, 0.5);
}

.ocbc:hover {
  box-shadow: 0px 0px 10px 3px rgba(238, 39, 34, 0.5);
  border: none;
}

.bagi:hover {
  border: none;
  box-shadow: 0px 0px 10px 3px rgba(162, 133, 72, 0.5);
}

.cimb-syariah:hover {
  border: none;
  box-shadow: 0px 0px 10px 3px rgba(103, 0, 21, 0.5);
}

.choose-bank img {
  width: 100%;
}

.content-modal {
  width: 520px;
}

.body-modal {
  padding: 15px 0;
  min-height: 100px;
  text-align: center;
}

.footer-modal {
  margin: 0;
  display: flex;
  justify-content: space-between;
}

.btn-primer,
.btn-scondary {
  height: 40px;
  width: 140px;
  font-size: 14px;
}

.btn-scondary {
  background: none;
  border: 1px solid #c59733;
  margin-left: 20px;
}

.btn-scondary:focus {
  border: none;
  background: var(--scondary);
  color: #fff;
  box-shadow: 0 0 0 0.3rem rgba(197, 151, 51, 0.4);
}

label {
  font-size: 14px;
}

.label {
  width: 25%;
}

.form-input {
  width: 70%;
  padding: 0 15px;
}

.clickCheck {
  width: 17px;
  height: 20px;
  position: absolute;
  top: -7px;
  left: -2px;
  z-index: 3;
  cursor: pointer;
}

@media (min-width: 720px) and (max-width: 1024px) {
  .hello {
    flex-wrap: wrap;
  }

  .content-left {
    text-align: center;
  }

  .content-right {
    margin: 0px 0 0 50px;
  }

  .btn-primer {
    width: 150px;
    margin: 0 15px 0 0;
  }

  .btn-scondary {
    width: 150px;
  }
}

.img-error {
  margin-top: -33px;
  height: 95px;
}

.img-error img {
  width: 135px;
}
</style>
